var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthAndSafety24DpFill1Wght300Grad0Opsz24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M430-450v69.62q0 12.76 8.81 21.57t21.57 8.81h39.24q13.15 0 21.76-8.81 8.62-8.81 8.62-21.57V-450h69.62q13.15 0 21.76-8.81 8.62-8.81 8.62-21.57v-39.24q0-13.15-8.62-21.76-8.61-8.62-21.76-8.62H530v-69.62q0-13.15-8.62-21.76-8.61-8.62-21.76-8.62h-39.24q-12.76 0-21.57 8.62-8.81 8.61-8.81 21.76V-550h-69.62q-12.76 0-21.57 8.62-8.81 8.61-8.81 21.76v39.24q0 12.76 8.81 21.57t21.57 8.81H430Zm50 344.84q-6.23 0-12.23-1t-11.62-3q-126.53-45-201.34-159.57Q180-383.31 180-516v-180.15q0-22.7 13.16-40.96 13.15-18.27 33.84-26.5l227.69-85q12.85-4.62 25.31-4.62 12.46 0 25.31 4.62l227.69 85q20.69 8.23 33.84 26.5Q780-718.85 780-696.15V-516q0 132.69-74.81 247.27-74.81 114.57-201.34 159.57-5.62 2-11.62 3-6 1-12.23 1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthAndSafety24DpFill1Wght300Grad0Opsz24);
export default __webpack_public_path__ + "static/media/health_and_safety_24dp_FILL1_wght300_GRAD0_opsz24.fc826344ccc5d9d0d92d24079ca28796.svg";
export { ForwardRef as ReactComponent };